
define(
	'C3.ShoppingExtensions.CartPage'
,   [
		//'C3.ShoppingExtensions.CartPage.View',
		'ProductList.DetailsLaterMacro.View',
		'C3.ShoppingExtensions.HomeHeader',
		'LiveOrder.Model',
		'Utils',
		/*'C3.ShoppingExtensions.CartPage.RecentlyView',*/
		'C3.ShoppingExtensions.CartPage.RecentlyView.Main',
		/*'C3.ShoppingExtensions.CartPage.RelatedItemsView',*/
		'C3.ShoppingExtensions.CartPage.RelatedItems.Main',
		'Cart.Detailed.View',
		'ProductList.DetailsLater.View',
		'Backbone.CollectionView',
		'product_list_details_later.tpl',
		'products_detail_later_cell.tpl',
		'backbone_collection_view_row.tpl',
		'c3_shoppingextensions_cartpage_saveforlater_itemcell.tpl',
		'C3.ShoppingExtensions.LoginRegister.View',
		'C3.ShoppingExtensions.CartPage.QuickAdd.View',
		'QuickOrder.View',
		'C3.ShoppingExtensions.HomeHeader.View',
		'Profile.Model',
		'Cart.Item.Summary.View',
		'Cart.Summary.View',
		'GlobalViews.Message.View',
		'Cart.Lines.View',
		'GoogleTagManager',
		'Tracker',
		'Cart.Item.Actions.View',
		'ProductDetails.AddToProductList.View',
		'C3.ShoppingExtensions.CartPage.Wishlist',
		'C3.ShoppingExtensions.CartPage.Wishlist.Rightside.View',
	//	'C3.ShoppingExtensions.CartPage.SaveForLaterMain.Wishlist',
		'ProductList.Model',
		'Product.Model',
		"C3.ShoppingExtensions.CartPage.SavedForLaterCustom"
	//	'C3.ShoppingExtensions.CartPage.AddToSaveForLater.View'
	]
,   function (
		//CartPageView,
		ProductListDetailsLaterMacroView,
		NXTurnShoppingExtensionsHomeHeader,
		LiveOrderModel,
		Utils,
		/*RecentlyView,*/
		RecentlyViewMain,
		/*RelatedItemsView,*/
		RelatedItemsMainView,
		CartDetailedView,
		ProductListDetailsLaterView,
		BackboneCollectionView,
		product_list_details_later_tpl,
		products_detail_later_cell_tpl,
		backbone_collection_view_row_tpl,
		c3_shoppingextensions_cartpage_saveforlater_itemcell_tpl,
		LoginRegisterView,
		QuickAddSearcherView,
		QuickOrderView,
		HeaderViewExt,
		ProfileModel,
		CartItemSummaryView,
		CartSummaryView,
		GlobalViewsMessageView,
		CartLinesView,
		GoogleTagManager,
		Tracker,
		CartItemActionsView,
		ProductDetailsAddToProductListView,
		CartPageWishlist,
		AddToWishlistRightSideCartView,
		//SaveForLaterMainWishlist,
		ProductListModel,
		ProductModel,
		CartSavedForLaterCustom
		//AddToSaveForLaterView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var environment = container.getComponent("Environment");
			var cartComponent = container.getComponent("Cart")
			var layout = container.getComponent('Layout');
			var Configuration = environment.application.Configuration;
			
			//console.log(cartComponent)
			if(cartComponent)
			{

				/*cartComponent.addChildView('SavedForLaterCustom', function myViewConstructor()
				  {
				  	return new CartSavedForLaterCustom({
				  		application: environment.application,
				  		container : container
				  	})
				  });*/

				/*CartDetailedView.addChildViews({	            
		            'SavedForLaterCustom': function wrapperFunction(options) {
		            	return function() {
		            		//console.log(options)
		            		return new CartSavedForLaterCustom({
						  		application: environment.application,
						  		container : container
						  	})
		            	}
		            }	
		        });*/	      

				  cartComponent.addChildView('CustomRecentlyViewed.Items', function myViewConstructor()
				  {
				  	return new RecentlyViewMain(
		                {application: environment.application,container : container});
				  	/*return new RecentlyView(
		                {application: environment.application,container : container});*/
				  });

				  cartComponent.addChildView('CustomQuickAddSearcher', function myViewConstructor()
				  {
				  	return new QuickAddSearcherView({
				  		application: environment.application,
				  		container : container
				  	})
				  });

				  CartDetailedView.addChildViews({	            
		            'CustomRelated.Items': function wrapperFunction(options) {
		                return function() {
		                	return new RelatedItemsMainView({
		                        itemsIds: options.model.getItemsIds(),
		                        application: environment.application,
		                        configuration : Configuration,
		                        container : container
		                    });
		                };
		            }
		        });


				/*CartDetailedView.addChildViews({	            
		            'SavedForLaterMainWishlist': function wrapperFunction(options) {
		                return function() {
				            return new SaveForLaterMainWishlist({
				                    application: layout.application
				                });
		                };
		            }
		        });*/


		       /* CartItemActionsView.addChildViews({	            
		            'SaveForLaterButton': function wrapperFunction(options) {
		                return function() {
				            return new SaveForLaterButtonView({
				                    application: layout.application
				                });
		                };
		            }
		        });  */
				  CartItemActionsView.prototype.getContext = _.wrap(CartItemActionsView.prototype.getContext, function (fn) {
					var result = fn.apply(this, arguments);	
	         		
	         		//img src based on item option in cart
		            var itemOptions = this.model.get('options')
		            ,   findOptionAdded = ''
		            if(itemOptions.length > 0)
		            {
		            	var line_options_models =  itemOptions.models  
		            	,   targetId = "custcol_inventory_number";
		            	if(line_options_models.length > 0)
		                   {
		                   	   var filteredOptions = line_options_models.find(option => option.get('cartOptionId') === targetId)
			                   if(filteredOptions){
				                   var getOptionValue = filteredOptions.get('value')
				                   if(getOptionValue)
				                   findOptionAdded = getOptionValue.internalid;
			               		}
		                   }
		            }
		            //console.log(findOptionAdded)

					_.extend(result, {														
								    hasSerialOption : findOptionAdded
								});


					return result;
			     });  
				CartLinesView.prototype.getContext = _.wrap(CartLinesView.prototype.getContext, function (fn) {
					var result = fn.apply(this, arguments);	
	         		
	         		//img src based on item option in cart
		            var itemOptions = this.model.get('options')
		            ,   findOptionImg = ''
		            ,   findOptionPrice = ''
		            ,   findOptionCosmetic = ''
		            ,   findOptionFunctional = ''
		            ,   findOptionDisposable = ''
		            if(itemOptions.length > 0)
		            {
		            	var line_options_models =  itemOptions.models  
		            	,   targetImgId = "custcol_inventory_number_image"
		            	,   targetPriceId = "custcol_webstore_asset_price"
		            	,   targetId = 'custcol_webstore_temp_data'

		            	//console.log(line_options_models)
		            	if(line_options_models.length > 0)
		                   {

		               		var filteredOptions = line_options_models.find(option => option.get('cartOptionId') === targetId)
			                   if(filteredOptions){
				                   var getOptionValue = filteredOptions.get('value')
				                   if(getOptionValue){
					                   var optionInteralid = getOptionValue.internalid;
					                   if(optionInteralid){
					                   	var parsedInfo = JSON.parse(optionInteralid)
					                   	findOptionCosmetic = parsedInfo.cosmetic
					                   	findOptionFunctional = parsedInfo.functional
					                   	findOptionDisposable = parsedInfo.disposable
					                   	findOptionImg = parsedInfo.imgurl;
					                   	findOptionPrice = parsedInfo.price;
					                   }
					                  
				              	   }

			               		}
		                   }

		            }

					var bogoConfig = Configuration.PRODUCTPAGEBOGO || {};
					var bogoItemsList = bogoConfig.config || [];
					var showBOGO = false;
					var cartLineItemId = String(this.model.get('item').get('internalid'));
					for (var b = 0; b < bogoItemsList.length; b++) {
						if (String(bogoItemsList[b].itemid) === cartLineItemId) {
							showBOGO = true;
							break;
						}
					}

					_.extend(result, {
								    optionImg : findOptionImg,
								    optionPrice : Utils.formatCurrency(findOptionPrice),
									optionCosmetic : findOptionCosmetic,
									optionFunctional : findOptionFunctional,
									optionDisposable : findOptionDisposable,
									showBOGO : showBOGO
								});


					return result;
			     });

				CartDetailedView.prototype.getBreadcrumbPages = HeaderViewExt.getBreadcrumbPages;  
				
				const self = this;
/*
				layout.addToViewEventsDefinition(
				'Cart.Item.Actions.View',
				'click [data-action="save-for-later-wishlist"]',
				function (e) 
				{
					e.preventDefault();

					const livModel = LiveOrderModel.getInstance();			

					const cart_line = livModel.get('lines').get(jQuery(e.target).data('internalid'))
			        ,     internalid = cart_line.get('internalid')
			        ,     currentItemfromLines = cart_line.get('item')
			        const whole_promise = jQuery.Deferred();
			        
			        jQuery
		            .when(AddToSaveForLaterView.addItemToWishlist(currentItemfromLines,layout.application))
		            .then(function() {
		                layout.application.getLayout().showConfirmationMessage(
		                    Utils.translate(
		                        'Good! You saved the item for later. If you want to add it back to your cart, see below in <b>"Saved for later"</b>'
		                    )
		                );

		                whole_promise.resolve();
		            });

				});*/


				/*layout.addToViewEventsDefinition(
				'ProductList.DetailsLaterMacro.View',
				'click [data-action="item-quick-view"]',
				function (e) 
				{
					NXTurnShoppingExtensionsHomeHeader.showQuickView(e,environment.application,layout);
				});*/

				ProductListDetailsLaterMacroView.prototype.getContext = _.wrap(ProductListDetailsLaterMacroView.prototype.getContext, function (fn) {
				var result = fn.apply(this, arguments);

				var applyStrikeThroughPrice = false
				,   special_formatted_pricelevel1 = ''
				,   special_formatted_pricelevel5 = ''
				,   item = this.model.get('item')
				,   qtyAvailableInv = item.get('custitem_qty_available_inv')
				,   qtyAvailableKit = item.get('custitem_qty_available_kit')
				,   itemType = item.get('itemtype')
				,   serialLotFunctionality = item.get('custitem_pdp_seriallot_number_function')
				,   serialLotMinPrice = item.get('custitem_icm_ain_min_price')
				,   serialLotMaxPrice = item.get('custitem_icm_ain_max_price')
				,   enableOutOfStock = item.get('custitem_celigo_shopify_enable_out_sto')
				,   isWebsiteCategoryProduct = item.get('custitem157')
				,   outOfStockDisplay = item.get('custitem_aa_out_of_stock_display')
	            ,   showContactForPricingButton = false
	            ,   showOutOfStockButton = false
	            ,   showOutofStock = false;	

				//console.log(qtyAvailableInv);


				if(qtyAvailableInv == undefined)
				qtyAvailableInv = 0;

				if(qtyAvailableKit == undefined)
				qtyAvailableKit = 0;

				if(itemType == "Kit")
				{
					//Item Qty is 0 and Allow out of stock checkbox is not checked
					if(qtyAvailableKit <= 0 && enableOutOfStock == false)
					{
						showOutofStock = true;

						if(outOfStockDisplay == "Out of Stock")
			                showOutOfStockButton = true;
			            else if(outOfStockDisplay == "Contact for Pricing")
			                showContactForPricingButton = true;
					}
				}
				else if(itemType == 'InvtPart' || itemType == 'Assembly')
				{
					//Item Qty is 0 and Allow out of stock checkbox is not checked
					if(qtyAvailableInv <= 0 && enableOutOfStock == false)
					{
						showOutofStock = true;

						if(outOfStockDisplay == "Out of Stock")
			                showOutOfStockButton = true;
			            else if(outOfStockDisplay == "Contact for Pricing")
			                showContactForPricingButton = true;
					}
				}


				var lightboxItem = item.get('custitem_lightbox_item_url_component');
				var finalLightboxUrl = ''
				,   isKitItemOnly = item.get('custitem_kit_item_only') 


				if(lightboxItem !== '' /*&& kititemonly == true*/)
				{
					finalLightboxUrl = "/"+lightboxItem;
				}

				//console.log(item)
				//if(this.options.origin !== "mostpopular")
				//{
				var price_detail = item.get('onlinecustomerprice_detail')
				,   ItemPrice = ''
				//console.log(price_detail)
				if(price_detail)
				{
					var price_container_object = item.getPrice()
					,   pricelevel1 = item.get('pricelevel1')
					,   pricelevel1_formatted = item.get('pricelevel1_formatted')
					,   onlinecustomerprice_detail = price_detail
					,   applyStrikeThroughPrice = false
					,   onlineprice = onlinecustomerprice_detail.onlinecustomerprice
					,   pricelevel5 = onlinecustomerprice_detail.onlinecustomerprice 
					,   ItemPrice = onlinecustomerprice_detail.onlinecustomerprice_formatted
					,	savePrice = 0
					,	savePercent=0
					,	discountPercentage=0;

					if(pricelevel1 && pricelevel1 > onlineprice)
					{
						//console.log(pricelevel1.toLocaleString('en'));
						applyStrikeThroughPrice = true;
					}

					if(pricelevel1_formatted)
						special_formatted_pricelevel1 = pricelevel1_formatted.substr(0, pricelevel1_formatted.indexOf('.'));
					
					if(price_container_object)
					{
						onlineprice = price_container_object.price_formatted;
						if(onlineprice)
						special_formatted_pricelevel5 = onlineprice.substr(0, onlineprice.indexOf('.'));
					}	

					var currPrice = pricelevel5 || pricelevel1 || 0; 
		            if( currPrice < 5){
		                showOutofStock = true;
		            }
				 }
				//}

				var itemQtyInCurrentOrder = 0;

				//using lightbox field condition instead of relateditems
				//if(subCategoriesList.length  == 0)
				if(lightboxItem == '')
				{
					var self = this;
					var liveOrder = LiveOrderModel.getInstance();
					//console.log(liveOrder.get('lines'))
					
					var lineData=liveOrder.get('lines').filter(function(line)
					{	
						return line.get('item').get('internalid') == item.get('_id');
			       	});
			       	if(lineData.length > 0)
			       	{
			       	var lineQuantity=lineData[0].get('quantity');
			       	itemQtyInCurrentOrder = lineQuantity;
			       	}
				}


				/*if(isKitItemOnly == true)
					showOutofStock = true;*/

				if(applyStrikeThroughPrice)
	            {
	            	savePrice = parseFloat((Number(pricelevel1) - Number(pricelevel5)).toFixed(2));
	            	discountPercentage = (savePrice / pricelevel1) * 100;
	            	savePercent=Math.trunc(discountPercentage)+ "%";
	            }
				//console.log(isWebsiteCategoryProduct)
				_.extend(result, {
					     itemQtyInCurrentOrder : itemQtyInCurrentOrder
			        ,    itemQtyInCurrentOrderCheck : itemQtyInCurrentOrder > 0
			        ,    itemQtyInCurrentOrderCheck2 : itemQtyInCurrentOrder < 1
			        ,    origin : this.options.origin
			        ,    hideArrows : this.options.hideArrows
			        ,    applyStrikeThroughPrice : applyStrikeThroughPrice
					,    BasePriceFormatted : special_formatted_pricelevel1
					,    OnlinePriceFormatted : special_formatted_pricelevel5
					,    dontAllowMoveToCart : showOutofStock || showContactForPricingButton || showOutOfStockButton
					,    plpPrice : ItemPrice
					,	 isWebsiteCategoryProduct : isWebsiteCategoryProduct
					,	 lightBoxItemURL : finalLightboxUrl
					,	 savePrice : savePrice
					,    savePercent:savePercent
					,    serialLotFunctionality : serialLotFunctionality
					,    serialLotMinPrice: Utils.formatCurrency(serialLotMinPrice)
					,    serialLotMaxPrice: Utils.formatCurrency(serialLotMaxPrice)
					,    hasSerialMinMax: (serialLotMinPrice != null && serialLotMinPrice !== '') && (serialLotMaxPrice != null && serialLotMaxPrice !== '')
					,    hasSerialMinOnly: (serialLotMinPrice != null && serialLotMinPrice !== '') && !(serialLotMaxPrice != null && serialLotMaxPrice !== '')
					,    hasSerialMaxOnly: !(serialLotMinPrice != null && serialLotMinPrice !== '') && (serialLotMaxPrice != null && serialLotMaxPrice !== '')
					,    serialMinMaxEqual: (serialLotMinPrice != null && serialLotMinPrice !== '') && (serialLotMaxPrice != null && serialLotMaxPrice !== '') && parseFloat(serialLotMinPrice) === parseFloat(serialLotMaxPrice)
				})

				//console.log(result)

				return result;
		     });


				layout.addToViewEventsDefinition(
				'Cart.Summary.View',
				'click [data-action="show-login-register-popup"]',
				function (e) 
				{
					e.stopPropagation();
					e.preventDefault();

					var view = new LoginRegisterView({
						application: layout.application
					});

					if (view)
					layout.showContent(view, {showInModal: true});
				});


				layout.addToViewEventsDefinition(
				'Cart.Detailed.View',
				'click [data-action="show-login-register-popup"]',
				function (e) 
				{
					e.stopPropagation();
					e.preventDefault();

					var view = new LoginRegisterView({
						application: layout.application
					});

					if (view)
					layout.showContent(view, {showInModal: true});
				});

				layout.addToViewEventsDefinition(
				'QuickOrder.View',
				'click [data-action="quick-order-dropdown"]',
				function (e) 
				{
					e.stopPropagation();
					e.preventDefault();

					//console.log(e)
					$('.custom-quick-order-section .icon-title').css('display','none');
					$('.custom-quick-order-section .input-section').css('display','block');
					$('#quickadd-search').focus();
					//$('#quickaddSearch').attr('placeholder','')
					/*$('#quickaddSearch').focus();
					$('#quickaddSearch').removeAttribute('placeholder');*/
				});


				layout.addToViewEventsDefinition(
				'ProductList.DetailsLaterMacro.View',
				'click [data-action="minus"]',
				function (e) 
				{
					const $element = jQuery(e.currentTarget);
			        const quantity_input = $element.parent().find('.item-quantity-value');
			       	const find_title_ele = $element.closest('.e2');
			        const old_value = quantity_input.text();
			       	const cart = SC.Application('Shopping').getComponent('Cart');
			    	var lines=[];

			        if(old_value==1 )
			        {
			        	var parentEle = $element.parent('.plus-icon');
				        if(parentEle.hasClass('expand-plus-icon'))
				        parentEle.removeClass('expand-plus-icon');

			        	find_title_ele.removeClass('newly-added-css');
			        	let new_val = parseFloat(old_value) - 1;
						quantity_input.text(new_val);
			        	$element.attr("style","display:none !important;");
			        	quantity_input.hide();
			        }
			        else if(old_value>1 ){
			        	let new_val = parseFloat(old_value) - 1;
			        	quantity_input.text(new_val);

			        	if(old_value == 2)
			        	{
			        		var trashCane = $element.parent().find('.product-trash-tray');
					    	var button_minus = $element.parent().find('.minus-button');
					    	//console.log(button_minus)
					    	button_minus.attr("style","display:none !important;");
					    	trashCane.show();
					    	quantity_input.css('text-align','left');
				        	
			        	}
			        }
			    	var internalID=quantity_input.attr("data-id");
					
					var liveOrder = LiveOrderModel.getInstance();
					
					var lineData=liveOrder.get('lines').filter(function(line)
					{	
						return line.get('item').get('internalid') == internalID;
			       	});
			       	var lineQuantity=lineData[0].get('quantity');
			       	
			       	if(lineQuantity==1)
			       		liveOrder.removeLine(
			       		lineData[0].set('quantity',parseFloat(lineQuantity)-1));
			    	else
			    	{
			    		liveOrder.updateLine(
			       		lineData[0].set('quantity',parseFloat(lineQuantity)-1));
			       		setTimeout(function(){
			    			if(!Utils.isPhoneDevice())
			    				jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
			    		}, 1000);
			    	}
				});

				layout.addToViewEventsDefinition(
				'ProductList.DetailsLaterMacro.View',
				'click [data-action="plus"]',
				function (e) 
				{
						var self = this;

						var $element = jQuery(e.currentTarget);
				        var quantity_input = $element.parent().find('.item-quantity-value');
				        var button_minus = $element.parent().find('.minus-button');
				       	var find_title_ele = $element.closest('.e2');
				       	var cart = SC.Application('Shopping').getComponent('Cart');
				    	var lines=[];

				    	var itemQtyInCurrentOrder = 0;

				    	var liveOrder = LiveOrderModel.getInstance();
						//console.log(self.model.get('_id'))

						var internalID=quantity_input.attr("data-id");

						//console.log(internalID)
						
						var lineData=liveOrder.get('lines').filter(function(line)
						{	
							return line.get('item').get('internalid') == internalID;
				       	});
				       	
				       	if(lineData.length > 0)
				       	{
				       	var lineQuantity=lineData[0].get('quantity');
				       	itemQtyInCurrentOrder = lineQuantity;
				       	}

					    var elementParent = $element.parent('.plus-icon');		
						//console.log(elementParent)

				    	var trashCane = $element.parent().find('.product-trash-tray');
				    	
				       // console.log(find_title_ele)
				        quantity_input.show();
				       // button_minus.show();

				        var parentEle = $element.parent('.plus-icon');
				        if(!(parentEle.hasClass('expand-plus-icon')))
				        parentEle.addClass('expand-plus-icon');

				        find_title_ele.addClass('newly-added-css');
				        
				        var old_value = quantity_input.text();

				         if(elementParent.hasClass('add-to-cart-buttons-opened'))
			       		 {
						var new_val = parseFloat(old_value) == 0 ? 1 : parseFloat(old_value)+1; 
						quantity_input.text(new_val);
						}
						
						var quantity = quantity_input.text();
						var internalID=quantity_input.attr("data-id");


						if(quantity == 1)
				        {
				        	trashCane.show();
				        	button_minus.hide();
				        	quantity_input.css('text-align','left');
				        	
				        }
				        else	
				        {
				        	 button_minus.show();
				        	trashCane.hide();
				        	quantity_input.css('text-align','center');
				        }

				        //console.log(quantity)
						
						if(quantity>0)
						{
							//console.log(itemQtyInCurrentOrder)
							if(itemQtyInCurrentOrder && !(elementParent.hasClass('add-to-cart-buttons-opened')))
							{
								$element.text('+');
								$element.removeClass('plus-button-additional');

								elementParent.addClass('add-to-cart-buttons-opened');
								elementParent.removeClass('plus-icon-additional');

							}else
							{
								var lineData={quantity: parseFloat(1),
									  		  item: {internalid: parseFloat(internalID)}
								};
								//console.log(lineData)
								lines.push(lineData);
								SC.loadingIndicatorShow();
								cart.addLines({lines: lines}).then(function() {
									SC.loadingIndicatorHide();
									if(!Utils.isPhoneDevice())
									jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");
								});
								elementParent.addClass('add-to-cart-buttons-opened');	
							}
						}
				});

				
				/*layout.addChildView('CustomRecentlyViewed.Items', function () 
		        {
		           //console.log('lay')
		           return new RecentlyView(
		                {application: environment.application});
		        });*/

		        /*layout.addChildView('CustomRelated.Items', function () 
		        {
		           //console.log('lay')
		           return new RelatedItemsView(
		                {application: environment.application});
		        });*/


		        /*CartDetailedView.addChildViews({
		            'CustomRecentlyViewed.Items': function wrapperFunction(options) {
		            	//console.log(options)
		                return new RecentlyView(
		                {application: environment.application});
		            },
		            'CustomRelated.Items': function wrapperFunction(options) {
		            	//console.log(options.model.getItemsIds())
		                return function() {
		                    return new RelatedItemsView({
		                        itemsIds: options.model.getItemsIds(),
		                        application: environment.application
		                    });
		                };
		            }
		        });*/

		        layout.addToViewEventsDefinition(
				'ProductList.DetailsLater.View',
				'click [data-action="show-all-saved-items"]',
				function (e) 
				{
					var anchor = jQuery(e.currentTarget)
					,   data_param = anchor.attr('data-parameter');

					var parentEle = $('.ProductList-DetailsLater-Collection')
					,   children = parentEle.children()
					,   children_length = children.length;

					if(data_param == 'show-more'){
						children.removeClass("hide-these-sections");
						$('.product-list-details-later-list-items .see-less-link').css('display','block');
						$('.product-list-details-later-list-items .see-all-link').css('display','none');
					}
					else if (data_param == 'show-less'){
						
						children.addClass("hide-these-sections");
						var firstChild = children.first();
						firstChild.removeClass('hide-these-sections')

						$('.product-list-details-later-list-items .see-all-link').css('display','block');
						$('.product-list-details-later-list-items .see-less-link').css('display','none');
					}
					
				});

		        /*ProductListDetailsLaterView.addChildViews({
		        	'ProductList.DetailsLater.Collection': function wrapperFunction(options) {
		            	//console.log(this.model.get('items'))
		            	var viewsPerRowItems = 5;

		            	if(Utils.isPhoneDevice())
		            		viewsPerRowItems = 2;

		            	var self = this;
		                return new BackboneCollectionView({
			                collection: self.model.get('items'),
			                childView: ProductListDetailsLaterMacroView,
			                viewsPerRow: viewsPerRowItems,
			                //cellTemplate: nxturn_shoppingextensions_cartpage_saveforlater_itemcell_tpl,
			                cellTemplate: products_detail_later_cell_tpl,
			                rowTemplate: backbone_collection_view_row_tpl,
			                childViewOptions: {
			                    application: environment.application
			                }
			            });
		            }
		        });*/



	         layout.addToViewContextDefinition('QuickOrder.View', 'hasExistingKeyword', 'boolean', function(context) {
		            
	                var currentURL = window.location.href
		            ,   keywordFromUrl = false
		            

		            if(currentURL.indexOf('?quickaddkeyword=') > -1)
		                keywordFromUrl = true

		            return keywordFromUrl;
		      });


	         

	         	layout.addToViewContextDefinition('Cart.Confirmation.View', 'isPhoneDevice', 'boolean', function(context) {
			            return Utils.isPhoneDevice();
			      });

	         	layout.addToViewContextDefinition('Cart.Item.Actions.View', 'isLoggedIn', 'boolean', function(context) {
			            
	         			var profile = ProfileModel.getInstance()
						,   is_logged_in = (profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F')

			            return is_logged_in;
			      });

	         	

	         	layout.addToViewContextDefinition('Cart.Item.Summary.View', 'isPhoneDevice', 'boolean', function(context) {
			            return Utils.isPhoneDevice();
			      });

	         	layout.addToViewContextDefinition('Cart.Summary.View', 'isPhoneDevice', 'boolean', function(context) {
			            return Utils.isPhoneDevice();
			      }); 
	         
		        /*ProductListDetailsLaterView.prototype.getContext = _.wrap(ProductListDetailsLaterView.prototype.getContext, function (fn) {
				var result = fn.apply(this, arguments);

					_.extend(result, {
						     isPhoneDevice : Utils.isPhoneDevice()
					});


				return result;

				});*/


				/*CartItemActionsView.addChildViews({
		         	'AddToProductListFromCart': function wrapperFunction(options) {
		         		return function() {
		         			return new ProductDetailsAddToProductListView({
		         				application: options.application,
		         				model : options.model
		         			});
		         		}
		         	}
		         });*/


				CartItemActionsView.addChildViews({
		         	'AddToProductListFromCartPage': function wrapperFunction(options) {
		         		//console.log(options)
		         		return function() {
		         			return new CartPageWishlist({
		         				application: options.application,
		         				model : options.model/*,
		         				iscartpage : true*/
		         			});
		         		}
		         	}
		         });


				CartDetailedView.addChildViews({
		         	'AddToWishlistCart.RightSide': function wrapperFunction(options) {
		         		//console.log(options)
		         		/*var mod = options.model
		         		var item = mod.get('item');*/
		         		var header_view_options = _.extend(
	                    {
		                        application: options.application,
		                       // item: item
		                    },
		                    {}
		                );
	                  return new AddToWishlistRightSideCartView(header_view_options);
		         	}
		         });

				layout.addToViewEventsDefinition(
				'Cart.Detailed.View',
				'click [data-action="cart-hide-rightside-wishlist"]',
				function (e) 
				{
					//console.log(e)
					var dontCloseFlag = false;

		            if (e.target.tagName === 'A') {
		                if (this.activeLink) {
		                    this.activeLink.removeClass('active');
		                }
		                this.activeLink = jQuery(e.target);
		                this.activeLink.addClass('active');
		            }else if(e.target.tagName === 'SPAN')
		            {
		                dontCloseFlag = true;
		            } 

		            if(dontCloseFlag == false)
		            {
		            jQuery('.main').removeClass('wishlist-rightside-bar-opened');
		            jQuery('.sidebar-close-rightside-bar').hide();

		            jQuery('.header-secondary-wrapper-mobile').show();

		            jQuery('.shopping-layout-header').css("box-shadow","rgb(153, 153, 153) 0px 1px 10px")

		            jQuery('.wishlist-sidebar-overlay-sec').hide();

		            if(Utils.isPhoneDevice())
		            jQuery('.cart-detailed-savedforlater .product-list-details-later-row').show();

		            $('.wishlist-title h1').text('Add to your Wish List');
		            $('.create-new-wishlist').show();
		            $('.product-list-control-new-item-add-new-list-form').hide()    
		            //jQuery('.header-sidebar-relatedcategories-overlay-mobile').show();

		            jQuery('.shopping-layout-header').addClass('shopping-layout-header-no-hamburger-scroll')
		            jQuery('.myaccount-layout-header').addClass('myaccount-layout-header-no-hamburger-scroll')
		            }  
				});


				 /*ProductDetailsAddToProductListView.prototype.getContext = _.wrap(ProductDetailsAddToProductListView.prototype.getContext, function (fn) {
					var result = fn.apply(this, arguments);

					var isCartPage = this.options.iscartpage || false;

					_.extend(result, {
									isCartPage : isCartPage	     
									});

					return result;

				});	*/

				layout.addToViewEventsDefinition(
				'Cart.Item.Summary.View',
				'change [data-action="changeCartItemQuantity"]',
				function (e) 
				{
					var $element = jQuery(e.currentTarget)
					,   line_old_qty = $element.attr('data-quantity')
					,   line_selected_qty = $element.val()
					,   line_new_qty = 0
					,   line_internalid = $element.attr('data-internalid')

					//console.log(line_internalid)


					$element.siblings('.select-kindof').css('display','block')
					//console.log(line_old_qty)
					const quantity_input = $element.parent().find('input');

					quantity_input.val(line_selected_qty);
        			quantity_input.change();

        			if(line_old_qty !== line_selected_qty)
        			{
        				//setTimeout(function(){
		        			//Snippet for GTM DataLayer
		        			var liveOrder = LiveOrderModel.getInstance();

		                    var cartLinesDL = liveOrder.get('lines')
		                    ,   cartLinesModelsDL = cartLinesDL.models
		                    ,   finalCartArray = []

		                    _.each(cartLinesModelsDL, function(line) {
		                        var lineItem = line.get('item')
		                        ,   lineItemName = lineItem.get('displayname')
		                        ,   lineItemSKU = lineItem.get('itemid')
		                        ,   lineQty = line.get('quantity')
		                        ,   lineRate = line.get('rate')

		                        ,   lineGroup = lineItem.get('custitemproduct_category')
								,   lineCategory =  lineItem.get('custitem168')

								finalCartArray.push({
								    'item': lineItemSKU,
								    'quantity':  lineQty,
								    'price': lineRate,
								    'unique_id': lineItemSKU,
								    'ProductGroup' : lineGroup,
								    'ProductCategory' : lineCategory

								})
		                    });
		                    //console.log(finalCartArray)
		                    const gtm = GoogleTagManager;
		                    const eventName = 'cartInfo';
		                     const eventData = {
		                        event: eventName,
		                        cartUpdates: finalCartArray
		                     }
		                     Tracker.trigger(eventName, eventData);
		                     /*var dataLay = gtm.win.dataLayer;
		                      
		                     var find_dl = _.findWhere(dataLay, {
			                    event: 'cartInfo'
			                });*/
		                    
		                    //if(find_dl) 
		                     gtm.pushData(eventData);

		                     //console.log(gtm.win);

		                     //console.log(finalCartArray)
	                        /*var _etmc = [];
							_etmc.push(['trackCart', {
							    'cart': finalCartArray
							}]);*/
	                     //}, 500);
		                     //setTimeout(function() { 
                            var appendParentElement = $('.append-abandoned-cart-items')
                            appendParentElement.html('<script>var _etmc = _etmc || [];_etmc.debug=true;_etmc.push(["setOrgId", "534010071"]);_etmc.push(["trackCart", {"cart": '+JSON.stringify(finalCartArray)+'}]);</script>') 
                         //}, 1000); 
                     }

				});

		        layout.addToViewEventsDefinition(
				'Cart.Item.Summary.View',
				'click [data-action="changeCartItemQuantity"]',
				function (e) 
				{
					var $element = jQuery(e.currentTarget)
					,   line_old_qty = $element.attr('data-quantity')
					,   line_selected_qty = $element.val()
					,   line_new_qty = 0
					,   line_internalid = $element.attr('data-internalid')

					//console.log(line_internalid)


					$element.siblings('.select-kindof').css('display','block')
					//console.log(line_old_qty)
					const quantity_input = $element.parent().find('input');

					quantity_input.val(line_selected_qty);
        			quantity_input.change();

        			if(line_old_qty !== line_selected_qty)
        			{
        				//setTimeout(function(){
		        			//Snippet for GTM DataLayer
		        			var liveOrder = LiveOrderModel.getInstance();

		                    var cartLinesDL = liveOrder.get('lines')
		                    ,   cartLinesModelsDL = cartLinesDL.models
		                    ,   finalCartArray = []

		                    _.each(cartLinesModelsDL, function(line) {
		                        var lineItem = line.get('item')
		                        ,   lineItemName = lineItem.get('displayname')
		                        ,   lineItemSKU = lineItem.get('itemid')
		                        ,   lineQty = line.get('quantity')
		                        ,   lineRate = line.get('rate')
								,   lineGroup = lineItem.get('custitemproduct_category')
								,   lineCategory =  lineItem.get('custitem168')

								finalCartArray.push({
								    'item': lineItemSKU,
								    'quantity':  lineQty,
								    'price': lineRate,
								    'unique_id': lineItemSKU,
								    'ProductGroup' : lineGroup,
								    'ProductCategory' : lineCategory

								})
		                    });
		                    //console.log(finalCartArray)
		                    const gtm = GoogleTagManager;
		                    const eventName = 'cartInfo';
		                     const eventData = {
		                        event: eventName,
		                        cartUpdates: finalCartArray
		                     }
		                     Tracker.trigger(eventName, eventData);
		                     /*var dataLay = gtm.win.dataLayer;
		                      
		                     var find_dl = _.findWhere(dataLay, {
			                    event: 'cartInfo'
			                });*/
		                    
		                    //if(find_dl) 
		                     gtm.pushData(eventData);

		                     //console.log(gtm.win);
		                     //console.log(finalCartArray)
	                       /* var _etmc = [];
							_etmc.push(['trackCart', {
							    'cart': finalCartArray
							}]);*/
	                     //}, 500);
		                 //setTimeout(function() { 
                            var appendParentElement = $('.append-abandoned-cart-items')
                            appendParentElement.html('<script>var _etmc = _etmc || [];_etmc.debug=true;_etmc.push(["setOrgId", "534010071"]);_etmc.push(["trackCart", {"cart": '+JSON.stringify(finalCartArray)+'}]);</script>') 
                         //}, 1000);     
                     }

				});


		        /*layout.addToViewEventsDefinition(
				'Cart.Item.Summary.View',
				'click [data-action="changeCartItemQuantity"]',
				function (e) 
				{
					var $element = jQuery(e.currentTarget)
					,   line_old_qty = $element.attr('data-quantity')
					,   line_selected_qty = $element.val()
					,   line_new_qty = 0

					$element.siblings('.select-kindof').css('display','block')

				});*/

				layout.addToViewEventsDefinition(
				'Cart.Item.Summary.View',
				'click [data-action="select-this-quantity"]',
				function (e) 
				{
					var $element = jQuery(e.currentTarget)
					,   line_new_qty = $element.attr('data-qty')
					

					$element.parent('.select-kindof').css('display','none')
					const quantity_input = $element.parent().parent().siblings('input');
					
					quantity_input.val(line_new_qty);
        			quantity_input.change();

				});


		        CartItemSummaryView.prototype.getContext = _.wrap(CartItemSummaryView.prototype.getContext, function (fn) {
					var result = fn.apply(this, arguments);

					var item = this.model.get('item')
					,   qtyAvailableInv = item.get('custitem_qty_available_inv')
					,   qtyAvailableKit = item.get('custitem_qty_available_kit')
					,   itemType = item.get('itemtype')
					,   cartItemAvailableQuantity = 0
					,   cartItemAvailableQuantityArray = []
					,   currentQuantity = result.line.get('quantity')
					,   special_formatted_pricelevel1 = ''
					,   special_formatted_pricelevel5 = ''

					if(qtyAvailableInv == undefined)
						qtyAvailableInv = 0;

					if(qtyAvailableKit == undefined)
						qtyAvailableKit = 0;

					if(itemType == 'Kit')
					{
						if(qtyAvailableKit > 0)
						cartItemAvailableQuantity = qtyAvailableKit;
					}
					else if(itemType == 'InvtPart' || itemType == 'Assembly')
					{
						if(qtyAvailableInv > 0)
						cartItemAvailableQuantity = qtyAvailableInv;
					}

					/*var price_detail = item.get('onlinecustomerprice_detail')
					,   ItemPrice = ''
					//console.log(price_detail)
					if(price_detail)
					{
						var price_container_object = item.getPrice()
						,   pricelevel1 = item.get('pricelevel1')
						,   pricelevel1_formatted = item.get('pricelevel1_formatted')
						,   onlinecustomerprice_detail = price_detail
						,   applyStrikeThroughPrice = false
						,   onlineprice = onlinecustomerprice_detail.onlinecustomerprice
						,   pricelevel5 = onlinecustomerprice_detail.onlinecustomerprice 
						,   ItemPrice = onlinecustomerprice_detail.onlinecustomerprice_formatted
					
						if(pricelevel1 && pricelevel1 > onlineprice)
						{
							//console.log(pricelevel1.toLocaleString('en'));
							applyStrikeThroughPrice = true;
						}

						if(pricelevel1_formatted)
							special_formatted_pricelevel1 = pricelevel1_formatted.substr(0, pricelevel1_formatted.indexOf('.'));
						
						if(price_container_object)
						{
							onlineprice = price_container_object.price_formatted;
							if(onlineprice)
							special_formatted_pricelevel5 = onlineprice.substr(0, onlineprice.indexOf('.'));
						}	

						if(pricelevel5 == 0 && pricelevel1 == 0)
			            {
			            	showOutofStock = true
			            }
			            else if(pricelevel5 == null)
			            {
			            	showOutofStock = true
			            }
					 }
*/
					//console.log(result.line.get('quantity'))
					
					for(var a=1;a<=cartItemAvailableQuantity;a++){
							cartItemAvailableQuantityArray.push({
								'isActive' : a == currentQuantity ? true : false,
								'quantity' : a,
								'lineid' : result.lineId
							})
					}

					//if qty of item is oos but when moved to cart from Saved for later to cart.
					if(cartItemAvailableQuantity <= 0)
					{
						cartItemAvailableQuantity = result.line.get('quantity');
						for(var a=1;a<=result.line.get('quantity');a++){
							cartItemAvailableQuantityArray.push({
								    'isActive' : a == currentQuantity ? true : false,
									'quantity' : a,
									'lineid' : result.lineId
							})
						}
					}

					_.extend(result, {
						     		 cartItemAvailableQuantityArray : cartItemAvailableQuantityArray
						        ,    quantityAvailableInStock : _.isNumber(cartItemAvailableQuantity) &&  cartItemAvailableQuantity > 0 ? true : false
						        /*,    BasePriceFormatted : special_formatted_pricelevel1
								,    OnlinePriceFormatted : special_formatted_pricelevel5
								,    plpPrice : ItemPrice*/
					});

					//console.log(result);

					return result;
				});

				CartDetailedView.prototype.getContext = _.wrap(CartDetailedView.prototype.getContext, function (fn) {
				var result = fn.apply(this, arguments);

				//console.log(this.model.get('lines'))
				var summary = this.model.get('summary')
				,   totalFormatted = ''
				,   lines = ''

				/*var profile = ProfileModel.getInstance()
				,   is_logged_in = (profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F')
           		*/			
				//console.log(is_logged_in)

				if(summary)
				    totalFormatted = summary.total_formatted
				    lines = this.model.get('lines')

				/*var lines = this.model.get('lines')
				,   itemHasNoAvailableQuantity = false

				_.each(lines.models,function(line){
					var item = line.get('item')
					,   type = item.get('type')
					,   qtyAvailableInv = item.get('custitem_qty_available_inv')
				    ,   qtyAvailableKit = item.get('custitem_qty_available_kit')   

					if(type == 'Kit')
					{
						if(qtyAvailableKit < 1)
						itemHasNoAvailableQuantity = true;
					}
					else if(type == 'InvtPart')
					{
						if(qtyAvailableInv < 1)
						itemHasNoAvailableQuantity = true;
					}
				});   */ 
				//console.log(itemHasNoAvailableQuantity)

				_.extend(result, {
						     cartItemsCount : lines.length,
						     cartIsEmpty : lines.length < 1 ? true : false,
						     cartItemsMoreThanOne : lines.length > 1 ? true : false,
						     totalFormatted : totalFormatted,
						     //isLoggedIn : is_logged_in,
						     //showOutOfStockErrorMessage : true/*itemHasNoAvailableQuantity*/
					});

				//console.log(result)
				return result;

				});


				/*CartSummaryView.prototype.getContext = _.wrap(CartSummaryView.prototype.getContext, function (fn) {
					var result = fn.apply(this, arguments);

					
					var lines = this.model.get('lines')
					,   itemHasNoAvailableQuantity = false
					,   strykerProduct = false
					,   blockContinueToCheckout = false
					,   strykerUSRestriction = false

					//console.log(lines)
					_.each(lines.models,function(line){
						var item = line.get('item')
						,   type = item.get('itemtype')
						,   qtyAvailableInv = item.get('custitem_qty_available_inv')
					    ,   qtyAvailableKit = item.get('custitem_qty_available_kit')  
					    ,   manufacturerName = item.get('custitem_manufacturer') 

					    //console.log(item)

					    if(manufacturerName == 'Stryker')
				    	strykerProduct = true;

						if(type == 'Kit')
						{
							if(qtyAvailableKit < 1){
								itemHasNoAvailableQuantity = true;
								blockContinueToCheckout = true;
							}
							
						}
						else if(type == 'InvtPart')
						{
							if(qtyAvailableInv < 1){
								itemHasNoAvailableQuantity = true;
								blockContinueToCheckout = true;
							}
							
						}
					});

					//Stryker shipping to US restriction functionality
					var profile = ProfileModel.getInstance();

					if(profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F')
					{
						var addressBook = profile.get('addressbook');

		                var find_shippingAddr = _.findWhere(addressBook, {
		                    defaultshipping: 'T'
		                });

		                if(find_shippingAddr)
		                {

	                    var srtykerResitrictCountries = Configuration.StrykerRestrictedCountries
		                    ,   srtykerResitrictConfig = srtykerResitrictCountries.config

		                    
		                    _.each(srtykerResitrictConfig,function(country){
		                    	if(country.countrycode == find_shippingAddr.country && strykerProduct)
		                    	{
		                    		strykerUSRestriction = true;
		                    		blockContinueToCheckout = true;
		                    	}
		                    })
		                }
					}

					//console.log(itemHasNoAvailableQuantity);

					_.extend(result, {
						     itemHasNoAvailableQuantity : itemHasNoAvailableQuantity,
						     blockContinueToCheckout : blockContinueToCheckout,
						     strykerUSRestriction : strykerUSRestriction
					});

					//console.log(result)
					return result;

				});	*/

				 /*layout.addToViewContextDefinition('Cart.Lines.View', 'showCartItemOOSMessage', 'boolean', function(context) {
			            
			            var cartItemOOS = false
			            ,   itemInfo = context.item
			            ,   type = itemInfo.itemtype
						,   qtyAvailableInv = itemInfo.custitem_qty_available_inv
					    ,   qtyAvailableKit = itemInfo.custitem_qty_available_kit   
						
						//console.log(itemInfo)
					    if(type == 'Kit')
						{
							if(qtyAvailableKit < 1)
							cartItemOOS = true;
						}
						else if(type == 'InvtPart')
						{
							if(qtyAvailableInv < 1)
							cartItemOOS = true;
						}

			            //console.log(cartItemOOS)

			            return cartItemOOS;
			      });*/


			      layout.addToViewContextDefinition('Cart.Lines.View', 'showCartItemStrykerMessage', 'boolean', function(context) {
			            
			            var cartItemOOS = false
			            ,   itemInfo = context.item
			            ,   type = itemInfo.itemtype
						,   qtyAvailableInv = itemInfo.custitem_qty_available_inv
					    ,   qtyAvailableKit = itemInfo.custitem_qty_available_kit 
					    ,   manufacturerName = itemInfo.custitem_manufacturer
					    ,   strykerProduct = false    
					    ,   strykerUSRestriction = false
						
						if(manufacturerName == 'Stryker')
				    	strykerProduct = true;

					    //Stryker shipping to US restriction functionality
						var profile = ProfileModel.getInstance();

						if(profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F')
						{
							var addressBook = profile.get('addressbook');

			                var find_shippingAddr = _.findWhere(addressBook, {
			                    defaultshipping: 'T'
			                });

			                if(find_shippingAddr)
			                {
		                    	var srtykerResitrictCountries = Configuration.StrykerRestrictedCountries
			                    ,   srtykerResitrictConfig = srtykerResitrictCountries.config
			                    
			                    _.each(srtykerResitrictConfig,function(country){
			                    	if(country.countrycode == find_shippingAddr.country && strykerProduct)
			                    	{
			                    		strykerUSRestriction = true;
			                    	}
			                    })
			                }
						}

			            return strykerUSRestriction;
			      }); 

			      layout.addToViewContextDefinition('Cart.Lines.View', 'cartItemStrykerMessage', 'string', function(context) {
			            var cartStrykerMessage = Configuration.PDPStrykerMessage
						,   cartStrykerMessageConfig = cartStrykerMessage.config
						//console.log(cartStrykerMessageConfig)

						return cartStrykerMessageConfig
					});	

			}

		}


		/*,
		addItemToWishlist: function(currentItem,application){
			console.log(currentItem)
			const defer = jQuery.Deferred();
			var itemModel = new ProductModel({
                internalid: currentItem.get('internalid'),
                quantity: 1,
                item : currentItem
            });

            var cutils =
                application.ProductListModule && application.ProductListModule.Utils;
            var collection = cutils.getProductLists();

            
            var findSFL  = _.find(collection.models, function(coll) {
                return coll.get('typeName') === "predefined" &&  coll.get('typeId') === "3";
            });
            console.log(findSFL)
            return defer.promise();	
		}*/
	};
});
